export enum FacebookRegistrationStatus {
  COMPLETE_REGISTRATION = 'COMPLETE_REGISTRATION',
  INCOMPLETE_REGISTRATION = 'INCOMPLETE_REGISTRATION',
}
